import { __assign, __awaiter, __extends, __generator } from "tslib";
import React, { Component } from "react";
import { PnmacSectionListView, PnmacPageBubble, PnmacRowHeader, PnmacRowItem, PnmacCard, PnmacMediaQuery, PnmacMeta, PnmacLinearProgress, PnmacText, PnmacHtmlToNative, PnmacUIButton, PnmacModal, PnmacTitle } from 'pnmac-universal-components';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import styles from '../styles/styles.js';
import moment from 'moment';
import { currencyFormatter, windowObject } from '../utils.js';
import { View, Image, Platform, ScrollView } from 'react-native';
import { textStyle } from '../v2/theme';
import BannerView from '../v2/BannerView';
import withPnmacTitle from '../withPnmacTitle';
import SimplyIOATile from '../components/SimplyIOATile.js';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from "../redux/events/events.js";
var lpiModalContent;
var fairPlanModalContent;
var LoanEscrow = /** @class */function (_super) {
  __extends(LoanEscrow, _super);
  function LoanEscrow(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      loanId: 0,
      openFairPlanLPIModal: false,
      modalContent: ""
    };
    _this.expRef = /*#__PURE__*/React.createRef();
    var that = _this;
    window.openPopUp = function (popupName) {
      if (popupName === 'lpiClicked') {
        that.setState({
          modalContent: lpiModalContent
        });
        that.setState({
          openFairPlanLPIModal: true
        });
      } else if (popupName === 'fairPlanClicked') {
        that.setState({
          modalContent: fairPlanModalContent
        });
        that.setState({
          openFairPlanLPIModal: true
        });
      }
    };
    return _this;
  }
  // This will be called only once after the component mounts
  LoanEscrow.prototype.componentDidMount = function () {
    this.tracker();
  };
  // Method to capture tracker details
  LoanEscrow.prototype.tracker = function () {
    this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Escrow Page Clicked ", 0);
  };
  LoanEscrow.prototype.render = function () {
    var _this = this;
    var _a, _b, _c;
    var _d = this.props,
      translations = _d.translations,
      layout = _d.layout;
    var _e = this.state,
      openFairPlanLPIModal = _e.openFairPlanLPIModal,
      modalContent = _e.modalContent;
    var escrow = (_a = layout === null || layout === void 0 ? void 0 : layout.currentLoanActivity) === null || _a === void 0 ? void 0 : _a.eescrow;
    var taxes = (escrow === null || escrow === void 0 ? void 0 : escrow.taxes) || [];
    var insurances = (escrow === null || escrow === void 0 ? void 0 : escrow.insurances) || [];
    var mortgage = escrow === null || escrow === void 0 ? void 0 : escrow.mortgageInsurance;
    var escrowPagePolicyContent = translations === null || translations === void 0 ? void 0 : translations.EscrowPagePolicy;
    var LPIInsuranceLineContent = translations === null || translations === void 0 ? void 0 : translations.LPIInsuranceLineContent;
    LPIInsuranceLineContent = LPIInsuranceLineContent === null || LPIInsuranceLineContent === void 0 ? void 0 : LPIInsuranceLineContent.replace("{0}", Platform.OS === 'web' ? "onclick=window.openPopUp(\'lpiClicked\')" : "onClick=openFairPlanLPIModal(lpiClicked);");
    var fairPlanInsuranceLineContent = translations === null || translations === void 0 ? void 0 : translations.FairPlanInsuranceLineContent;
    fairPlanInsuranceLineContent = fairPlanInsuranceLineContent === null || fairPlanInsuranceLineContent === void 0 ? void 0 : fairPlanInsuranceLineContent.replace("{0}", Platform.OS === 'web' ? "onclick=window.openPopUp(\'fairPlanClicked\')" : "onClick=openFairPlanLPIModal(fairPlanClicked);");
    var lpiCodes = ["ASREO", "ASPOL"];
    var fairPlanCodes = ["ABU00", "CFP00", "HS826", "HS826", "CPZ04", "CNN02", "DOP00", "GEU02", "HPA02", "ILP01", "IBP00", "IPD01", "0632P", "3110P", "KAF01", "KFP02", "LCP00", "MPU01", "6O673", "MCH01", "MFP00", "MSR00", "MIW01", "MPI00", "NJI00", "NFP02", "NCI00", "NPU00", "OHU00", "OFA00", "RIJ03", "0132P", "TFP01", "TXM00", "VIP02", "WFP00", "WAB00", "WII01"];
    var hazardInsurance = (_c = (_b = layout === null || layout === void 0 ? void 0 : layout.currentLoanActivity) === null || _b === void 0 ? void 0 : _b.loan) === null || _c === void 0 ? void 0 : _c.hazardInsuranceSummary;
    var lpi = hazardInsurance.some(function (item) {
      var _a;
      return lpiCodes.includes((_a = item === null || item === void 0 ? void 0 : item.hazardInsurancePayeeCode) === null || _a === void 0 ? void 0 : _a.trim());
    });
    var fairPlan = hazardInsurance.some(function (item) {
      var _a;
      return fairPlanCodes.includes((_a = item === null || item === void 0 ? void 0 : item.hazardInsurancePayeeCode) === null || _a === void 0 ? void 0 : _a.trim());
    });
    if (lpi && fairPlan) {
      escrowPagePolicyContent = escrowPagePolicyContent === null || escrowPagePolicyContent === void 0 ? void 0 : escrowPagePolicyContent.replace("{0}", LPIInsuranceLineContent + fairPlanInsuranceLineContent);
    } else if (lpi) {
      escrowPagePolicyContent = escrowPagePolicyContent === null || escrowPagePolicyContent === void 0 ? void 0 : escrowPagePolicyContent.replace("{0}", LPIInsuranceLineContent);
    } else if (fairPlan) {
      escrowPagePolicyContent = escrowPagePolicyContent === null || escrowPagePolicyContent === void 0 ? void 0 : escrowPagePolicyContent.replace("{0}", fairPlanInsuranceLineContent);
    } else {
      escrowPagePolicyContent = escrowPagePolicyContent === null || escrowPagePolicyContent === void 0 ? void 0 : escrowPagePolicyContent.replace("{0}", "");
    }
    var lpiModalFAQ = translations === null || translations === void 0 ? void 0 : translations.LpiModalFAQ;
    var lpiModalText = translations === null || translations === void 0 ? void 0 : translations.LpiModalText;
    lpiModalContent = Platform.OS === 'web' ? lpiModalFAQ + lpiModalText : lpiModalFAQ;
    var fairPlanModalFAQ = translations === null || translations === void 0 ? void 0 : translations.FairPlanModalFAQ;
    var fairPlanModalText = translations === null || translations === void 0 ? void 0 : translations.FairPlanModalText;
    fairPlanModalContent = Platform.OS === 'web' ? fairPlanModalFAQ + fairPlanModalText : fairPlanModalFAQ;
    var paidbyCustomerFlag = false;
    if (taxes === null || taxes === void 0 ? void 0 : taxes.find(function (s) {
      return s.paidByBorrower == true;
    })) {
      paidbyCustomerFlag = true;
    }
    var DATAEXPANDABLE = [{
      title: "".concat(translations === null || translations === void 0 ? void 0 : translations.EscrowInformationAsOf, " ").concat(moment().format("MMMM Do, YYYY")),
      data: [{
        label: translations.LoanNumber,
        header: "".concat(translations === null || translations === void 0 ? void 0 : translations.EscrowInformationAsOf, " ").concat(moment().format("MMMM Do, YYYY")),
        value: (escrow === null || escrow === void 0 ? void 0 : escrow.loanId) || "n/a"
      }, {
        label: translations.LastEscrowAnalysisDate,
        header: "".concat(translations === null || translations === void 0 ? void 0 : translations.EscrowInformationAsOf, " ").concat(moment().format("MMMM Do, YYYY")),
        value: (escrow === null || escrow === void 0 ? void 0 : escrow.lastAnalysisDate) ? moment(escrow === null || escrow === void 0 ? void 0 : escrow.lastAnalysisDate).format("MM/DD/YYYY") : "n/a"
      }, {
        label: translations.CurrentEscrowAccountBalance,
        header: "".concat(translations === null || translations === void 0 ? void 0 : translations.EscrowInformationAsOf, " ").concat(moment().format("MMMM Do, YYYY")),
        value: currencyFormatter('en-US', 'currency', 'USD', escrow === null || escrow === void 0 ? void 0 : escrow.currentBalance) || "n/a"
      }, {
        label: translations.CurrentEscrowPayment,
        header: "".concat(translations === null || translations === void 0 ? void 0 : translations.EscrowInformationAsOf, " ").concat(moment().format("MMMM Do, YYYY")),
        value: currencyFormatter('en-US', 'currency', 'USD', escrow === null || escrow === void 0 ? void 0 : escrow.currentPayment) || "n/a"
      }]
    }];
    taxes.map(function (s) {
      var _a, _b, _c, _d;
      var ta = DATAEXPANDABLE.find(function (d) {
        return d.title == (translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes);
      });
      if (!ta) {
        DATAEXPANDABLE.push({
          title: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          data: []
        });
        ta = DATAEXPANDABLE.find(function (d) {
          return d.title == (translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes);
        });
      }
      if (paidbyCustomerFlag) {
        ta.data.push({
          label: translations.PaidToMessage,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: s.payee || "n/a"
        }, {
          label: translations.PayeeAddress,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
            style: [textStyle.formBody, {
              textAlign: 'right'
            }]
          }, (_a = s.payeeAddress) === null || _a === void 0 ? void 0 : _a.address1), /*#__PURE__*/React.createElement(PnmacText, {
            style: [textStyle.formBody, {
              textAlign: 'right'
            }]
          }, (_b = s.payeeAddress) === null || _b === void 0 ? void 0 : _b.city))
        }, {
          label: translations.PayeePhone,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: s.payeePhone || "n/a"
        }, {
          label: translations.ParcelID,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: s.parcelId || "n/a"
        }, {
          label: translations.ResponsibleForPayment,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: translations.CustomerText
        });
      } else {
        ta.data.push({
          label: translations.PaidToMessage,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: s.payee || "n/a"
        }, {
          label: translations.PayeeAddress,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
            style: [textStyle.formBody, {
              textAlign: 'right'
            }]
          }, (_c = s.payeeAddress) === null || _c === void 0 ? void 0 : _c.address1), /*#__PURE__*/React.createElement(PnmacText, {
            style: [textStyle.formBody, {
              textAlign: 'right'
            }]
          }, (_d = s.payeeAddress) === null || _d === void 0 ? void 0 : _d.city))
        }, {
          label: translations.PayeePhone,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: s.payeePhone || "n/a"
        }, {
          label: translations.ParcelID,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: s.parcelId || "n/a"
        }, {
          label: translations.DisbursementFrequency,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: s.disbursementFrequency || "Unknown"
        }, {
          label: translations.LastDisbursementDate,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: s.lastPaidDate ? moment(s.lastPaidDate).format("MM/DD/YYYY") : "n/a"
        }, {
          label: translations.NextDisbursementDate,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: s.nextDueDate ? moment(s.nextDueDate).format("MM/DD/YYYY") : "n/a"
        }, {
          label: translations.NextAmountDue,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: currencyFormatter('en-US', 'currency', 'USD', s.nextDueAmount) || "n/a"
        }, {
          label: translations.ResponsibleParty,
          header: translations === null || translations === void 0 ? void 0 : translations.ExpandTaxes,
          value: s.paidByBorrower ? translations.BorrowerText : translations.BorrowersBehalf
        });
      }
    });
    insurances.map(function (s) {
      var _a, _b;
      var ta = DATAEXPANDABLE.find(function (d) {
        return d.title == (translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances);
      });
      if (!ta) {
        DATAEXPANDABLE.push({
          title: translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances,
          data: []
        });
        ta = DATAEXPANDABLE.find(function (d) {
          return d.title == (translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances);
        });
      }
      ta.data.push({
        label: translations.InsuranceCompany,
        header: translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances,
        value: s.companyName || "n/a"
      }, {
        label: translations.CompanyAddress,
        header: translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances,
        value: /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
          style: [textStyle.formBody, {
            textAlign: 'right'
          }]
        }, (_a = s.companyAddress) === null || _a === void 0 ? void 0 : _a.address1), /*#__PURE__*/React.createElement(PnmacText, {
          style: [textStyle.formBody, {
            textAlign: 'right'
          }]
        }, (_b = s.companyAddress) === null || _b === void 0 ? void 0 : _b.city))
      }, {
        label: translations.CompanyPhone,
        header: translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances,
        value: s.companyPhone || "n/a"
      }, {
        label: translations.CoverageType,
        header: translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances,
        value: s.coverageType || "n/a"
      }, {
        label: translations.PolicyNumber,
        header: translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances,
        value: s.policyNumber || "n/a"
      }, {
        label: translations.LastDisbursementDate,
        header: translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances,
        value: s.lastPaidDate ? moment(s.lastPaidDate).format("MM/DD/YYYY") : "n/a"
      }, {
        label: translations.PolicyExpires,
        header: translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances,
        value: s.policyExpiration ? moment(s.policyExpiration).format("MM/DD/YYYY") : "n/a"
      }, {
        label: translations.PremiumAmount,
        header: translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances,
        value: currencyFormatter('en-US', 'currency', 'USD', s.premiumAmount) || "n/a"
      }, {
        label: translations.PolicyTerm,
        header: translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances,
        value: s.policyTerm ? "".concat(s.policyTerm, " ").concat(s.policyTerm > 1 ? "".concat(translations.MonthText, "s") : translations.MonthText) : "n/a"
      }, {
        label: translations.CoverageAmount,
        header: translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances,
        value: currencyFormatter('en-US', 'currency', 'USD', s.coverageAmount) || "n/a"
      }, {
        label: translations.NextDisbursementDate,
        header: translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances,
        value: s.nextDueDate ? moment(s.nextDueDate).format("MM/DD/YYYY") : "n/a"
      }, {
        label: translations.ResponsibleParty,
        header: translations === null || translations === void 0 ? void 0 : translations.HomeownersHazardInsurances,
        value: s.paidByBorrower ? translations.BorrowerText : translations.BorrowersBehalf
      });
    });
    if (mortgage) {
      DATAEXPANDABLE.push({
        title: translations.MortgageInsurance,
        data: [{
          label: translations.PaymentAmount,
          header: translations === null || translations === void 0 ? void 0 : translations.MortgageInsurance,
          value: currencyFormatter('en-US', 'currency', 'USD', mortgage.premiumAmount) || "n/a"
        }, {
          label: translations.NextDisbursementDate,
          header: translations === null || translations === void 0 ? void 0 : translations.MortgageInsurance,
          value: mortgage.nextDueDate ? moment(mortgage.nextDueDate).format("MM/DD/YYYY") : "n/a"
        }]
      });
    }
    var allowedSimplyIOAScriptNums = [1, 2, 4];
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      onRefresh: function () {
        _this.props.authenticate(false);
      },
      refreshing: layout.reloadingData,
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a, _b;
      return /*#__PURE__*/React.createElement(View, {
        style: {
          paddingHorizontal: 10
        }
      }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacModal, {
        open: openFairPlanLPIModal,
        onClose: function () {
          _this.setState({
            modalContent: ""
          });
          _this.setState({
            openFairPlanLPIModal: false
          });
        },
        style: {
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          borderRadius: 10,
          padding: 20,
          backgroundColor: "#f5f5f5",
          width: matches.small ? '80%' : 500,
          height: Platform.OS == 'web' ? "75%" : "25%"
        }
      }, /*#__PURE__*/React.createElement(ScrollView, {
        style: {
          flex: 1,
          height: "auto"
        },
        contentContainerStyle: {
          alignItems: 'center',
          flexGrow: 1,
          paddingVertical: Platform.OS == 'web' ? 40 : 0,
          paddingHorizontal: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        value: modalContent,
        navigation: {
          navigate: function (params) {
            return __awaiter(_this, void 0, void 0, function () {
              var _this = this;
              return __generator(this, function (_a) {
                console.log("params", params);
                this.setState({
                  openFairPlanLPIModal: false
                }, function () {
                  _this.props.navigation.navigate(params);
                });
                return [2 /*return*/];
              });
            });
          }
        }
      }))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        style: {
          width: '80%'
        },
        mode: "outlined",
        onPress: function () {
          return _this.setState({
            openFairPlanLPIModal: false
          });
        }
      }, translations.GoBack))))), /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.escrowInformation
      }), allowedSimplyIOAScriptNums.includes((_b = (_a = layout === null || layout === void 0 ? void 0 : layout.simplyIOAData) === null || _a === void 0 ? void 0 : _a.scriptNumber) !== null && _b !== void 0 ? _b : 0) ? /*#__PURE__*/React.createElement(SimplyIOATile, {
        styles: {
          marginBottom: 20
        },
        matches: matches,
        navigation: _this.props.navigation,
        isEscrow: true
      }) : null, layout.isEligible ? /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginBottom: 20
        }
      }, !layout.pennyWise ? layout.banksToAdd && layout.banksToAdd.length > 0 && layout.banksToAdd.find(function (s) {
        return s.isEDisbursementAccount;
      }) ? /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
        value: translations.BorrowerEnrollForEdisb,
        navigation: _this.props.navigation,
        layout: layout
      }) : /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        value: translations.BorrowerNotEnrollForEdisb,
        navigation: _this.props.navigation,
        layout: layout
      })) : layout.banksToAdd && layout.banksToAdd.length > 0 && layout.banksToAdd.find(function (s) {
        return s.isEDisbursementAccount;
      }) ? /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        value: translations.PennyWiseBorrowerEnrollForEdisb,
        navigation: _this.props.navigation,
        layout: layout
      })) : /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        value: translations.PennyWiseBorrowerNotEnrollForEdisb,
        navigation: _this.props.navigation,
        layout: layout
      }))) : null, /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        value: escrowPagePolicyContent,
        navigation: {
          navigate: function (params) {
            return __awaiter(_this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                if (params === 'openFairPlanLPIModal(lpiClicked);') {
                  this.setState({
                    modalContent: lpiModalContent
                  });
                  this.setState({
                    openFairPlanLPIModal: true
                  });
                } else if (params === 'openFairPlanLPIModal(fairPlanClicked);') {
                  this.setState({
                    modalContent: fairPlanModalContent
                  });
                  this.setState({
                    openFairPlanLPIModal: true
                  });
                } else {
                  props.navigation.navigate(params);
                }
                return [2 /*return*/];
              });
            });
          }
        }
      }))), /*#__PURE__*/React.createElement(View, {
        style: layout.mobile ? __assign(__assign({}, styles.shadowStyles), {
          marginTop: 20
        }) : {
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacSectionListView, {
        openDefaults: ["".concat(translations === null || translations === void 0 ? void 0 : translations.EscrowInformationAsOf, " ").concat(moment().format("MMMM Do, YYYY"))],
        ref: _this.expRef,
        data: DATAEXPANDABLE,
        collapsableSections: true,
        renderItem: function (_a, collapsed) {
          var _b, _c;
          var index = _a.index,
            item = _a.item;
          if ((escrow === null || escrow === void 0 ? void 0 : escrow.loanId) > 0) {
            if (collapsed.some(function (s) {
              return s == item.header;
            })) {
              var notLastElement_1 = index <= ((_c = (_b = DATAEXPANDABLE.find(function (title) {
                return title.title == item.header;
              })) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.length) - 2;
              return /*#__PURE__*/React.createElement(PnmacRowItem, {
                renderChildren: function () {
                  var _a, _b, _c;
                  return /*#__PURE__*/React.createElement(View, {
                    style: __assign(__assign({}, (_a = styles.selectionListView) === null || _a === void 0 ? void 0 : _a.rowItemStyles), {
                      borderBottomLeftRadius: notLastElement_1 ? 0 : 10,
                      borderBottomRightRadius: notLastElement_1 ? 0 : 10
                    })
                  }, /*#__PURE__*/React.createElement(View, {
                    style: __assign(__assign({}, (_b = styles.selectionListView) === null || _b === void 0 ? void 0 : _b.fiftyWidth), {
                      fontSize: matches.small ? 14 : 16
                    })
                  }, /*#__PURE__*/React.createElement(PnmacText, {
                    style: textStyle.formBody
                  }, item.label)), /*#__PURE__*/React.createElement(View, {
                    style: __assign(__assign({}, (_c = styles.selectionListView) === null || _c === void 0 ? void 0 : _c.fiftyWidth), {
                      paddingRight: 10,
                      alignItems: Platform.OS !== 'web' ? 'flex-end' : 'flex-start'
                    })
                  }, /*#__PURE__*/React.createElement(PnmacText, {
                    style: [textStyle.formBody]
                  }, typeof item.value === 'string' ? item.value.trim() : item.value)));
                }
              });
            } else {
              return null;
            }
          } else {
            if (index == 0) {
              return /*#__PURE__*/React.createElement(PnmacLinearProgress, null);
            } else {
              return null;
            }
          }
        },
        renderSectionHeader: function (_a) {
          var _b, _c, _d, _e;
          var title = _a.section.title;
          var open = ((_c = (_b = _this.expRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
          return /*#__PURE__*/React.createElement(PnmacRowHeader, {
            rowHeaderStyles: styles.selectionListView.rowHeaderStyles,
            rowHeaderContainerStyles: layout.mobile ? {
              marginBottom: open ? 0 : 10,
              borderBottomWidth: open ? 1 : 0,
              borderBottomColor: "#EFEFEF",
              borderBottomLeftRadius: open ? 0 : 10,
              borderBottomRightRadius: open ? 0 : 10
            } : {
              borderBottom: open ? "1px solid #e9e9e9" : "none",
              borderBottomLeftRadius: open ? 0 : 10,
              borderBottomRightRadius: open ? 0 : 10
            },
            onClickExpand: function () {
              var _a, _b;
              return (_b = (_a = _this.expRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.collapseItem(title);
            },
            item: /*#__PURE__*/React.createElement(PnmacText, {
              id: title,
              style: textStyle.formTitleSection
            }, title),
            isExpand: ((_e = (_d = _this.expRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.state.collapsed.indexOf(title)) > -1
          });
        }
      })));
    });
  };
  return LoanEscrow;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(withPnmacTitle(LoanEscrow, function (props) {
  return props.translations.escrowInformation;
}));